import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { MagneticButton } from "@/components/MagneticButton";
import { GradientBlobs } from "@/components/GradientBlobs";

export const CTAFinale = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end end"] });
  const y = useTransform(scrollYProgress, [0, 1], [120, 0]);
  const opacity = useTransform(scrollYProgress, [0, 0.6], [0.2, 1]);

  return (
    <section
      ref={ref}
      className="relative overflow-hidden noise-overlay"
      data-testid="cta-section"
    >
      <GradientBlobs />
      <motion.div
        style={{ y, opacity }}
        className="relative z-10 mx-auto max-w-[1500px] px-6 md:px-12 py-16 md:py-28 text-center"
      >
        <Reveal>
          <span className="text-sm uppercase tracking-[0.3em] text-brand-ink/75">Ready when you are</span>
        </Reveal>
        <h2 className="mt-5 font-display font-extrabold tracking-tight leading-[0.95] text-5xl sm:text-6xl md:text-7xl lg:text-8xl">
          <span className="gradient-text-animated">Let&apos;s talk.</span>
        </h2>
        <Reveal delay={0.2}>
          <p className="mx-auto mt-6 max-w-2xl text-lg md:text-xl text-brand-ink/75">
            Let&apos;s turn your next challenge into your next opportunity.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <MagneticButton as="div" className="w-full sm:w-auto">
              <Link
                to="/contact"
                data-testid="cta-start-conversation"
                className="inline-flex w-full items-center justify-center gap-2 rounded-full gradient-bg px-9 py-4 text-base font-bold text-white shadow-xl shadow-brand-magenta/30 transition-shadow duration-300 hover:shadow-brand-orange/40 sm:w-auto"
              >
                START A CONVERSATION <ArrowUpRight className="h-5 w-5" />
              </Link>
            </MagneticButton>
            <Link
              to="/projects"
              data-testid="cta-view-projects"
              className="inline-flex w-full items-center justify-center gap-2 rounded-full border-2 border-brand-ink/25 px-9 py-4 text-base font-bold text-brand-ink transition-colors duration-300 hover:border-brand-primary hover:bg-brand-ink/5 sm:w-auto"
            >
              VIEW OUR PROJECTS
            </Link>
          </div>
        </Reveal>
      </motion.div>
    </section>
  );
};
